module.exports = __webpack_public_path__ + "res/28-img_top_center.3449ecb511c66cc874fba564d5059a92.png";